<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t($route.name)}}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
<log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo('academyCategory')"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('academyCategory') }}</span>
      </v-tooltip>
      <v-tooltip
        v-if="selected.length > 0"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon
              color="pink"
              style="font-size: 22px"
            >
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('remove') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              {{ (showSelect ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('select-row') }}</span>
      </v-tooltip>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        class="float-left"
        ref="refExcel"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              v-on="on"
            >
              <v-icon
                style="font-size: 22px"
                color="green"
              >
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('excel') }}</span>
        </v-tooltip>
      </export-excel>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="filter = true"
            >
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mb-2">
      <v-col
        class=" px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          solo
          flat
          height="30"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2 pt-0 "
    >
      <v-data-table
        v-if="headers"
        :height="tableHeight"
        fixed-header
        v-model="selected"
        :headers="showHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="goAttendance(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-format-list-checks
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyStudentAttendance', {name: $store.state.studentLabel})" />
              </v-list-item>
              <v-list-item
                link
                @click="studentList(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-account-school-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyStudentList', {name: $store.state.studentLabel})" />
              </v-list-item>
              <v-list-item
                v-if="!item.status"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.sum_cost="{ item }">
            {{ $numberFormat(parseFloat(item.sum_cost)) }} {{ $store.state.currencySymbol }}
        </template>
        <template v-slot:item.name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                text
                small
                v-on="on"
              >
                {{ item.event.name }}
              </v-btn>
            </template>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a>
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a>
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.arrayDays="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(day, index) in item.arrayDays"
              :key="index"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t(day) }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length) - 2}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('count') + ':' : '') }} {{ $numberFormat(totals.count) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('amount') + ':' : '') }} {{ $numberFormat(totals.amount) }}  {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="event"
              title="academyEventName"
              type="academyEvent"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="teacher"
              title="teacher"
              type="person"
              :new-btn="true"
              :data="JSON.stringify({type: 'teacher'})"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0 px-0">
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="sessionModal"
      width="500px"
    >
      <session-modal
        :selected-event="sessionSelect"
        @close="sessionModal = false"
        :hideBarBtnProp="true"
      />
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import SessionModal from './partial/sessionModal'
  export default {
    name: 'academyTeacherSessionCostList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Upload,
      Print,
      SessionModal,
      Task,
    },
    mixins: [General],
    props: ['input', 'type', 'refId', 'eventProp', 'teacherProp'],
    data: () => ({
      selected: [],
      inventoryStatus: null,
      inventoryStatusItems: null,
      group: null,
      sessionStatus: null,
      teacher: null,
      event: null,
      fromDate: null,
      toDate: null,
      status: null,
      excelItems: [],
      cat1: null,
      cat2: null,
      registerar: null,
      selectedHeaders: [],
      sessionSelect: null,
      sessionModal: false,
      uploadDialog: false,
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      productStatus: null,
      model: null,
      from: 1,
      pageCount: 1,
      page: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      // excelItems: [],
      search: null,
    }),
    computed: {
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.typeForm === 'service') {
            if (s.value === 'stock' || s.value === 'order_point') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d, index) => {
          acc.amount += parseFloat(d.sum_cost)
          acc.count += d.count_session
          return acc
        }, {
          amount: 0,
          count: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('teacher'),
          sortable: true,
          value: 'teacher.name',
          table: 'users.name',
        },
        {
          text: this.$t('academyEventName'),
          sortable: true,
          value: 'name',
          table: 'academy_category.name',
        },
        {
          text: this.$t('place'),
          sortable: true,
          value: 'place.name',
          table: 'academy_places.name',
        },
        {
          text: this.$t('startDate'),
          sortable: false,
          value: 'event.start_date',
        },
        {
          text: this.$t('startTime'),
          sortable: true,
          value: 'start_time',
          table: 'academy_events.start_time',
        },
        {
          text: this.$t('duration'),
          sortable: true,
          value: 'duration',
          table: 'academy_events.duration',
        },
        {
          text: this.$t('sessionCount'),
          sortable: false,
          value: 'count_session',
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum_cost',
        },
      ]
      this.statusItems = [
        {
          value: 'not-held',
          text: this.$t('not-held'),
        },
        {
          value: 'done',
          text: this.$t('done'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      if (this.teacherProp) {
        this.teacher = this.teacherProp
      }
      this.getItems()
    },
    methods: {
      openSessionModal (item) {
        this.sessionSelect = item
        this.sessionModal = true
      },
      goAttendance (item) {
        this.$router.push({ name: 'academyStudentAttendance', params: { sessionProp: item } })
      },
      studentList (item) {
        this.$router.push({ name: 'academyEventStudent', params: { eventProp: item.event } })
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'academyEventEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            teacherSessionCost: 'active',
            registerar: app.registerar,
            fromDate: app.fromDate,
            toDate: app.toDate,
            teacher: app.teacher,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            sortBy: app.sortBy,
            status: app.status,
            event: app.event,
            eventProp: app.eventProp,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.last_page = res.last_page
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academySession/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            name: String(d.teacher.name),
            event: (d.event ? d.event.name : ''),
            start_date: (d.event ? d.event.start_date : ''),
            start_time: (d.event ? d.event.start_time : ''),
            count: d.count_session,
            sum: d.sum_cost,
          })
        })
      },
    },
  }
</script>

<style scoped>

</style>
